// TrailGraph.jsx
import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer
} from 'recharts';

function TrailGraph({ fuelHistory }) {
  // Format fuelHistory into an array of objects with time and value
  const data = fuelHistory.map((value, index) => ({
    time: index,
    value: value.toFixed(1),
  }));

  return (
    <div className="bg-white rounded-lg shadow p-4 mt-6">
      <h4 className="text-lg font-semibold mb-3 text-gray-700">Fuel Level History</h4>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="time" label={{ value: 'Data Points', position: 'insideBottomRight', offset: 0 }} />
          <YAxis label={{ value: 'Fuel %', angle: -90, position: 'insideLeft' }} domain={[0, 100]} />
          <Tooltip />
          <Line type="monotone" dataKey="value" stroke="#10b981" dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default TrailGraph;
